import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.article`
	min-width: 100%;

	${minWidth('tablet')} {
		display: grid;
		grid-gap: 36px;
		grid-template-columns: 2fr 2fr;
		text-align: center;
	}
`;

export const TileImageContainer = styled.div`
	text-align: center;
`;

export const TileImage = styled.img`
	background: ${palette('white')};
	height: auto;
	margin: 0 auto 24px;
	max-width: 364px;
	width: 100%;

	${minWidth('tablet')} {
		margin: 0 auto;
	}
`;

export const Content = styled.div`
	color: #383838;
	text-align: center;

	${minWidth('tablet')} {
		text-align: left;
	}
`;

export const Heading = styled.h2`
	display: none;
	font-size: 36px;
	${fontWeight(FontWeights.Regular)};
	line-height: 1.5;
	margin-bottom: 24px;
	padding: 0;

	${minWidth('desktop')} {
		display: block;
	}
`;

export const Description = styled.p`
	font-size: 18px;
	line-height: 1.5;
	margin-bottom: 24px;
`;

export const ContentTitle = styled.div`
	font-size: 24px;
	${fontWeight(FontWeights.Medium)};
	line-height: 1.5;
	margin-bottom: 25px;
`;

export const BodyText = styled.p`
	font-size: 16px;
	line-height: 1.5;
`;
